import { Component, OnInit, ViewChild } from '@angular/core';
import { HeaderData } from 'src/app/_models/header-data';
import { AdminService } from '../_services/admin.service';
import { NgForm } from '@angular/forms';
import {FORM_MSGS} from '../../_common/product-config';
import { AuthenticationService } from 'src/app/user/_services/authentication.service';
import { Router } from '@angular/router';
import { StatusCode } from 'src/app/_common/_enum/module.enum';

@Component({
  selector: 'app-impersonate',
  templateUrl: './impersonate.component.html',
  styleUrls: ['./impersonate.component.scss']
})
export class ImpersonateComponent implements OnInit {

  @ViewChild("impersonateUserForm", {static: false}) impersonateUserForm: NgForm;
  @ViewChild("impersonatePolicyOrClaimForm", {static: false}) impersonatePolicyOrClaimForm: NgForm;

  private loadingUser: boolean = false;
  private loadingImperonatingUser: boolean = false;
  private loadingPolicyOrClaim: boolean = false;
  private loadingProfile: boolean = false;
  private user;
  private userNotFound:boolean = false;
  private companyList;
  private selectedCompany;
  private showSelectedCompany: boolean = false;
  private loadingImperonatingCompany: boolean = false;
  private impersonatedBy;
  private policy;
  private claim;
  private assigned:boolean = false;
  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;
  private formMsgs = FORM_MSGS;
  private hasAccess:boolean = false;

  //private killServicesOnDestroy = [];

  private psiData = null;
  
  searchTerm = "";
 
  constructor(private adminService: AdminService, private authenticationService: AuthenticationService, private router: Router) {
    //this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit() {    
    this.psiData = this.adminService.getData();

    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */

    this.fetchCompanyDetails();
    
  }

  setHeaderData(){
    this.headerData.pageTitle = "Profile Switching";
    if(this.adminService.isSuperAdmin){
      this.headerData.breadcrumb = [{itemName: "ADMIN", itemLink: "/admin"}];
    }else{
      this.headerData.breadcrumb = [{itemName: "Dashboard", itemLink: "/dashboard"}];
    }
    this.adminService.header = this.headerData;  
  }

  fetchCompanyDetails(){
    let companyDetailsSubscription = this.adminService.findProducersByCompany().subscribe((company:any)=>{
      this.companyList = company;
      this.impersonatedBy = this.companyList.find((_company)=>_company.companyID == this.psiData.currentUser.companyID);
      //this.impersonatedBy = this.selectedCompany;
    },error=>{
      this.companyList = null;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });
    this.adminService.runningServices.push(companyDetailsSubscription);
  }

  onUserSearch(){
    this.selectedCompany = null;
    this.userNotFound = false;
    this.assigned = false;
    this.showSelectedCompany = false;
    if(this.impersonateUserForm.valid && this.impersonateUserForm['username'] != undefined){
      this.loadingUser = true;
      let userDetailsSubscription = this.adminService.findProducersByUser(this.impersonateUserForm['username']).subscribe((user:any) => {
        this.loadingUser = false;
        this.userNotFound = (user == null);
        this.user = user;
      },error=>{
        this.loadingUser = false;
        this.userNotFound = true;
        this.user = null;
      });

      this.adminService.runningServices.push(userDetailsSubscription);
    }
  }
  impersonateByUser(email){
    if(email != "" && email != undefined){
      this.loadingImperonatingUser = true;

      let impersonateByUser = this.adminService.impersonateByUser(email).subscribe((user:any) => {
        this.loadingImperonatingUser = false;
        this.impersonatedBy = this.user;
        this.psiData = this.adminService.getData();
        this.psiData.currentUser.companyID = this.user.companyID;
        this.psiData.impersonatedBy = this.user;
        this.adminService.viewingAs = this.psiData.impersonatedBy;
        this.assigned = true;

        this.adminService.storeData(this.psiData);
        this.resetPermissions();
      },error=>{
        this.loadingImperonatingUser = false;
      });

      this.adminService.runningServices.push(impersonateByUser);
    }
  }
  selectCompany(company){
    this.user = null;
    this.userNotFound = false;
    this.assigned = false;
    this.showSelectedCompany = false;
    this.impersonateUserForm["username"] = "";
    this.selectedCompany = company;

    this.psiData = this.adminService.getData();
    this.psiData.currentUser.companyID = this.selectedCompany.companyID;
    this.psiData.impersonatedBy = this.selectedCompany;
    this.adminService.storeData(this.psiData);
    this.showSelectedCompany = (this.selectedCompany != undefined || this.selectedCompany!= null);
  }

  impersonateByCompany(company){
    this.userNotFound = false;
    if(company != "" && company != undefined){
      this.loadingImperonatingCompany = true;

      let impersonateByCpmpany = this.adminService.impersonateByCompany(company.companyID).subscribe((company:any) => {
        this.loadingImperonatingCompany = false;
        this.psiData = this.adminService.getData();
        this.impersonatedBy = this.selectedCompany;
        this.psiData.impersonatedBy = this.selectedCompany;
        this.adminService.viewingAs = this.psiData.impersonatedBy;
        this.assigned = true;

        this.adminService.storeData(this.psiData);
        this.resetPermissions();
      },error=>{
        this.loadingImperonatingCompany = false;
      });

      this.adminService.runningServices.push(impersonateByCpmpany);
    }
  }

  resetPermissions(){
    this.loadingProfile = true;
    let authorizeUser = this.authenticationService.authorize(this.psiData.currentUser).subscribe(user=>{
      /* setTimeout(() => {
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => { */
        this.loadingProfile = false;
        this.router.navigate(['/loading'], {skipLocationChange: true});
      /* });
      }, 50);  */ 
    },error=>{
      this.loadingProfile = false;
      this.authenticationService.logout();
    });

    this.adminService.runningServices.push(authorizeUser);
  }

  onPolicyOrClaimSearch(){
    if(this.impersonatePolicyOrClaimForm.valid && this.impersonatePolicyOrClaimForm['policyorclaim'] != undefined){
      this.loadingPolicyOrClaim = true;
      let policyOrClaimSubscription = this.adminService.findProducersByUser(this.impersonatePolicyOrClaimForm['policyorclaim']).subscribe((policyOrClaim:any) => {
        this.loadingPolicyOrClaim = false;
        this.policy = policyOrClaim;
        this.claim = policyOrClaim;
      },error=>{
        this.loadingPolicyOrClaim = false;
      });

      this.adminService.runningServices.push(policyOrClaimSubscription);
    }
  }
  ngOnDestroy() {
    this.adminService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}
